import React, { useId } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Collapse } from 'site-modules/shared/components/collapse/collapse';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';

export function ExplanatoryText(props) {
  const { summary, details, toggleSummary } = props;
  const id = useId();
  const [isOpen, toggle] = useToggle(false);

  return (
    <div>
      <span className="align-middle">{summary}</span>
      <button
        className="btn btn-link align-middle p-0 text-transform-none text-cool-gray-30 text-decoration-underline fw-normal size-16"
        onClick={toggle}
        data-tracking-id="expand_info"
        data-tracking-value={toggleSummary}
        aria-expanded={isOpen}
        aria-controls={id}
      >
        {toggleSummary}
        <span
          className={classNames('icon size-12 ms-0_5', {
            'icon-arrow-down3': !isOpen,
            'icon-arrow-up3': isOpen,
          })}
          aria-hidden
        />
      </button>
      <Collapse isOpen={isOpen} id={id}>
        {details}
      </Collapse>
    </div>
  );
}

ExplanatoryText.propTypes = {
  summary: PropTypes.node.isRequired,
  details: PropTypes.node.isRequired,
  toggleSummary: PropTypes.node.isRequired,
};
